import { PenTool, CreditCard, CalendarDays, CheckCircle2 } from 'lucide-react'
import { SignatureStep, PaymentStep, ScheduleStep, CompletionStep } from 'components/TreatmentPlan/Review'

export const statusFilterOptions = [
  { key: 'all', label: 'All' },
  { key: 'pending', label: 'Pending' },
  { key: 'completed', label: 'Completed' },
]

export const stepList = (patientSignatureRequired) => {
  return [
    ...(patientSignatureRequired ? [{ key: 'signature', label: 'Signature', icon: PenTool }] : []),
    { key: 'payment', label: 'Payment', icon: CreditCard },
    { key: 'schedule', label: 'Schedule', icon: CalendarDays },
    { key: 'completion', label: 'Completion', icon: CheckCircle2 },
  ]
}

export const stepComponents: Record<string, React.ComponentType<{ onNext: () => void; treatmentPlanId?: string; baseAppointmentId?: string }>> = {
  signature: SignatureStep,
  payment: PaymentStep,
  schedule: ScheduleStep,
  completion: CompletionStep,
}

export const getStepNumber = (patientSignatureRequired) => {
  return {
    decision_step: 0,
    payment_step: patientSignatureRequired ? 1 : 0,
    scheduling_step: patientSignatureRequired ? 2 : 1,
    progress_step: patientSignatureRequired ? 3 : 2,
    confirmation_step: patientSignatureRequired ? 3 : 2,
  }
}

export const filterValues = {
  all: null,
  pending: { in_progress: true },
  completed: { not_in_progress: true },
}
